module.exports = __webpack_public_path__ + "img/30_44.dfccf32b.png";